export enum AmountStageCode {
    mjp = "meerjarenplan"
}
